// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pop-up-box {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 12px 30px #757575;
    border-radius: 18px;
    width: 77rem;
}

.pop-up-img img {
    width: 100%;
}

.image-upload-box {
    position: relative;
    background: #d8d8d8 0% 0% no-repeat padding-box;
    padding: 15px;
    border-radius: 50px;
    margin: 0 19.5rem 0;
    cursor: pointer;
}

.image-upload-box input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.pop-up-section {
    margin: 0 -6rem 0;
}

.upload-imgbox {
    background: #d8d8d8 0% 0% no-repeat padding-box;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.upload-txt {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #234148;
    margin-top: 3px;
}

.profile-comment-img-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.profile-comment-img-row p {
    font: normal normal 600 16px/25px Poppins;
    letter-spacing: 0px;
    color: #000000;
    text-transform: capitalize;
}

.profile-comment-img-row img {
    width: 50px;
}

.timeline-comments {
    padding: 10px 0 0;
}

.friend-comments-section P {
    font: normal normal 600 12px/20px Poppins;
    letter-spacing: 0px;
    color: #8c8c8c;
}

.timeline-brand-content {
    height: 270px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 10px;
    margin-bottom: 15px;
}

.timeline-brand-content::-webkit-scrollbar {
    display: none;
}

.comment-img-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0 0;
}

.comment-img-row img {
    width: 30px;
}

.comment-img-row p {
    font: normal normal 600 12px/20px Poppins;
    letter-spacing: 0px;
    color: #000000;
}

.timeline-comment_text_area {
    position: relative;
}

.timeline-social_page_comment_text {
    width: 90%;
    background: #fff;
    padding: 10px 15px;
    border-radius: 30px;
    border: 1px solid #fff;
    box-shadow: 0px 3px 6px #00000029;
}

.timeline-comment_text_area button {
    border: none;
}

.timeline-comment_text_area i {
    float: right;
    top: 12px;
    position: absolute;
    right: 50px;
    color: #ffa91f;
    font-size: 20px;
}

.fa-paper-plane:before {
    content: "\\f1d8";
}

button.close {
    -webkit-appearance: none;
    padding: 6px 18px 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}

.friends-profile_header_bg img {
    width: 100%;
}

.timeline-profile_data_content {
    margin-top: -10px;
    margin-left: -20px;
}

.counting-follower {
    gap: 0.625rem;
    display: flex;
}

.counting-follower h6 {
    font: normal normal medium 20px/30px Poppins;
    letter-spacing: 0px;
    color: #000000;
    font-weight: 600;
}

.timelinefriends-counting-follower {
    gap: 0.625rem;
    display: flex;
}

.timelinefriends-counting-follower h6 {
    font: normal normal medium 20px/30px Poppins;
    letter-spacing: 0px;
    color: #000000;
    font-weight: 600;
}

.timelinefriends-profile_user_img img {
    height: 100%;
    border-radius: 50%;
}

.timelinefriends-profile_user_img {
    height: 100px;
    width: 100px;
    margin-right: 30px;
    position: relative;
    top: -50px;
    background: #fff;
    border-radius: 50%;
    padding: 3px;
}

.timelinefriends {
    display: flex;
}

.timelinefriends-profile_delete {
    margin-top: 40px;
}

@media (max-width: 767px) {
    .timelinefriends {
        display: block;
    }

    .timeline-profile_data_content {
        margin-top: -42px;
        margin-left: 0px;
    }

    .timelinefriends-profile_delete {
        margin-top: 15px;
    }

    .pop-up-img img {
        width: 57%;
    }

    .comments-section {
        padding: 2rem 6rem 0;
    }

    .classic_img_area {
        width: 235px;
        height: 235px;
    }

    .stash-pop-up-section {
        margin: 0 -30px 0;
    }

    .checking-btn-default {
        padding: 13px 78px !important;
    }

    .stash-pop-up-box {
        width: 38rem !important;
    }
}



.stash-pop-up-box {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 12px 30px #757575;
    border-radius: 16px;
    width: 40rem;
}

.stash-pop-up-section {
    text-align: -webkit-center;
}

.wishlist-Just-checking-section {
    padding: 10px;
    border-bottom: 1px solid #c4c4c4;
}

.wishlist-Just-checking-section h6 {
    font: normal normal medium 18px/27px Poppins;
    letter-spacing: 0px;
    color: #1e1e20;
    font-size: 14px;
    font-weight: 600;
}

.delete-section h6 {
    font: normal normal medium 20px/30px Poppins;
    letter-spacing: 0px;
    color: #1e1e20;
    font-size: 16px;
    font-weight: 600;
    padding: 22px 0 32px;
}

.checking-btn-default {
    padding: 13px 89px;
    font-weight: 600;
    color: white;
    margin-bottom: 0;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    background: #F8B518;
    border-radius: 0px 0px 16px 0px;
    border: none;
}

.checkingforyes-btn-default {
    padding: 13px 88px;
    font-weight: 600;
    color: #333;
    margin-bottom: 0;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    background: #9D9D9D 0% 0% no-repeat padding-box;
    border-radius: 0px 0px 0px 16px;
    border: none;
}

.checking-row {
    display: flex;
}

.addwishlist-pop-up-box {
    float: right;
    bottom: 6px;
    position: fixed;
    background: #e5cb21 0% 0% no-repeat padding-box;
    box-shadow: 0px 12px 30px #757575;
    width: 40rem;
    right: 2px;
    border-radius: 41px 0px 0px 41px;
    max-width: 100%;

}

.add-wishlist-row-section {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-left: 2px;
}

.add-wishlist-row-section h5 {
    font: normal normal medium 20px/30px Poppins;
    letter-spacing: 0px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
}

.add-wishlist-row-section img {
    width: 10%;
    cursor: pointer;
}

.mutual-one {
    position: relative;
}

.mutual-two {
    position: relative;
    left: -14px;
    z-index: 2;
    top: 0px;
}

.mutual-three {
    position: relative;
    top: 0px;
    left: -26px;
    z-index: 2;
}

.timelinefriends-counting-follower img {
    width: 24%;
    border-radius: 30px;
    border: 2px solid black;
}

.mutual-four {
    position: relative;
    top: 1px;
    left: -40px;
    z-index: 3;
}

.mutual-friend {
    width: 190px;
}

@media (max-width: 767px) {
    .mutual-four {
        position: relative;
        top: -40px;
        left: 90px;
        z-index: 3;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/UserTimeline/popup.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;IAC/C,iCAAiC;IACjC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;;;AAIA;IACI,+CAA+C;IAC/C,iCAAiC;IACjC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,+CAA+C;IAC/C,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,+CAA+C;IAC/C,iCAAiC;IACjC,YAAY;IACZ,UAAU;IACV,gCAAgC;IAChC,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,UAAU;IACd;AACJ","sourcesContent":[".pop-up-box {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 12px 30px #757575;\n    border-radius: 18px;\n    width: 77rem;\n}\n\n.pop-up-img img {\n    width: 100%;\n}\n\n.image-upload-box {\n    position: relative;\n    background: #d8d8d8 0% 0% no-repeat padding-box;\n    padding: 15px;\n    border-radius: 50px;\n    margin: 0 19.5rem 0;\n    cursor: pointer;\n}\n\n.image-upload-box input {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n}\n\n.pop-up-section {\n    margin: 0 -6rem 0;\n}\n\n.upload-imgbox {\n    background: #d8d8d8 0% 0% no-repeat padding-box;\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.upload-txt {\n    display: block;\n    font-size: 13px;\n    font-weight: 600;\n    color: #234148;\n    margin-top: 3px;\n}\n\n.profile-comment-img-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.profile-comment-img-row p {\n    font: normal normal 600 16px/25px Poppins;\n    letter-spacing: 0px;\n    color: #000000;\n    text-transform: capitalize;\n}\n\n.profile-comment-img-row img {\n    width: 50px;\n}\n\n.timeline-comments {\n    padding: 10px 0 0;\n}\n\n.friend-comments-section P {\n    font: normal normal 600 12px/20px Poppins;\n    letter-spacing: 0px;\n    color: #8c8c8c;\n}\n\n.timeline-brand-content {\n    height: 270px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin-top: 10px;\n    margin-bottom: 15px;\n}\n\n.timeline-brand-content::-webkit-scrollbar {\n    display: none;\n}\n\n.comment-img-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 0 0;\n}\n\n.comment-img-row img {\n    width: 30px;\n}\n\n.comment-img-row p {\n    font: normal normal 600 12px/20px Poppins;\n    letter-spacing: 0px;\n    color: #000000;\n}\n\n.timeline-comment_text_area {\n    position: relative;\n}\n\n.timeline-social_page_comment_text {\n    width: 90%;\n    background: #fff;\n    padding: 10px 15px;\n    border-radius: 30px;\n    border: 1px solid #fff;\n    box-shadow: 0px 3px 6px #00000029;\n}\n\n.timeline-comment_text_area button {\n    border: none;\n}\n\n.timeline-comment_text_area i {\n    float: right;\n    top: 12px;\n    position: absolute;\n    right: 50px;\n    color: #ffa91f;\n    font-size: 20px;\n}\n\n.fa-paper-plane:before {\n    content: \"\\f1d8\";\n}\n\nbutton.close {\n    -webkit-appearance: none;\n    padding: 6px 18px 0;\n    cursor: pointer;\n    background: 0 0;\n    border: 0;\n}\n\n.friends-profile_header_bg img {\n    width: 100%;\n}\n\n.timeline-profile_data_content {\n    margin-top: -10px;\n    margin-left: -20px;\n}\n\n.counting-follower {\n    gap: 0.625rem;\n    display: flex;\n}\n\n.counting-follower h6 {\n    font: normal normal medium 20px/30px Poppins;\n    letter-spacing: 0px;\n    color: #000000;\n    font-weight: 600;\n}\n\n.timelinefriends-counting-follower {\n    gap: 0.625rem;\n    display: flex;\n}\n\n.timelinefriends-counting-follower h6 {\n    font: normal normal medium 20px/30px Poppins;\n    letter-spacing: 0px;\n    color: #000000;\n    font-weight: 600;\n}\n\n.timelinefriends-profile_user_img img {\n    height: 100%;\n    border-radius: 50%;\n}\n\n.timelinefriends-profile_user_img {\n    height: 100px;\n    width: 100px;\n    margin-right: 30px;\n    position: relative;\n    top: -50px;\n    background: #fff;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.timelinefriends {\n    display: flex;\n}\n\n.timelinefriends-profile_delete {\n    margin-top: 40px;\n}\n\n@media (max-width: 767px) {\n    .timelinefriends {\n        display: block;\n    }\n\n    .timeline-profile_data_content {\n        margin-top: -42px;\n        margin-left: 0px;\n    }\n\n    .timelinefriends-profile_delete {\n        margin-top: 15px;\n    }\n\n    .pop-up-img img {\n        width: 57%;\n    }\n\n    .comments-section {\n        padding: 2rem 6rem 0;\n    }\n\n    .classic_img_area {\n        width: 235px;\n        height: 235px;\n    }\n\n    .stash-pop-up-section {\n        margin: 0 -30px 0;\n    }\n\n    .checking-btn-default {\n        padding: 13px 78px !important;\n    }\n\n    .stash-pop-up-box {\n        width: 38rem !important;\n    }\n}\n\n\n\n.stash-pop-up-box {\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 12px 30px #757575;\n    border-radius: 16px;\n    width: 40rem;\n}\n\n.stash-pop-up-section {\n    text-align: -webkit-center;\n}\n\n.wishlist-Just-checking-section {\n    padding: 10px;\n    border-bottom: 1px solid #c4c4c4;\n}\n\n.wishlist-Just-checking-section h6 {\n    font: normal normal medium 18px/27px Poppins;\n    letter-spacing: 0px;\n    color: #1e1e20;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.delete-section h6 {\n    font: normal normal medium 20px/30px Poppins;\n    letter-spacing: 0px;\n    color: #1e1e20;\n    font-size: 16px;\n    font-weight: 600;\n    padding: 22px 0 32px;\n}\n\n.checking-btn-default {\n    padding: 13px 89px;\n    font-weight: 600;\n    color: white;\n    margin-bottom: 0;\n    font-size: 14px;\n    text-align: center;\n    cursor: pointer;\n    background: #F8B518;\n    border-radius: 0px 0px 16px 0px;\n    border: none;\n}\n\n.checkingforyes-btn-default {\n    padding: 13px 88px;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 0;\n    font-size: 14px;\n    text-align: center;\n    cursor: pointer;\n    background: #9D9D9D 0% 0% no-repeat padding-box;\n    border-radius: 0px 0px 0px 16px;\n    border: none;\n}\n\n.checking-row {\n    display: flex;\n}\n\n.addwishlist-pop-up-box {\n    float: right;\n    bottom: 6px;\n    position: fixed;\n    background: #e5cb21 0% 0% no-repeat padding-box;\n    box-shadow: 0px 12px 30px #757575;\n    width: 40rem;\n    right: 2px;\n    border-radius: 41px 0px 0px 41px;\n    max-width: 100%;\n\n}\n\n.add-wishlist-row-section {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n    margin-left: 2px;\n}\n\n.add-wishlist-row-section h5 {\n    font: normal normal medium 20px/30px Poppins;\n    letter-spacing: 0px;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.add-wishlist-row-section img {\n    width: 10%;\n    cursor: pointer;\n}\n\n.mutual-one {\n    position: relative;\n}\n\n.mutual-two {\n    position: relative;\n    left: -14px;\n    z-index: 2;\n    top: 0px;\n}\n\n.mutual-three {\n    position: relative;\n    top: 0px;\n    left: -26px;\n    z-index: 2;\n}\n\n.timelinefriends-counting-follower img {\n    width: 24%;\n    border-radius: 30px;\n    border: 2px solid black;\n}\n\n.mutual-four {\n    position: relative;\n    top: 1px;\n    left: -40px;\n    z-index: 3;\n}\n\n.mutual-friend {\n    width: 190px;\n}\n\n@media (max-width: 767px) {\n    .mutual-four {\n        position: relative;\n        top: -40px;\n        left: 90px;\n        z-index: 3;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
